<template lang="pug">
.search-notification
  textbox-search.search-notification__action(v-model='titleNameValue', :placeholder='titleNamePlaceholder')
  button-search.search-notification__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'

/**
 * 塾絞り込み
 */
@Component({
  components: {
    TextboxSearch,
    ButtonSearch,
  },
})
export default class SearchNotification extends Vue {
  // 件名
  @Prop()
  titleName!: string

  // 件名プレースホルダー
  @Prop()
  titleNamePlaceholder!: string

  // 件名変更時のイベント
  @Prop()
  titleNameChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 件名
  get titleNameValue(): string {
    return this.titleName
  }
  set titleNameValue(value: string) {
    this.titleNameChangeEvent(value)
  }
}
</script>

<style lang="stylus" scoped>
.search-notification
  display flex

  &__action
    margin 7px 5px
</style>
